import { atom } from 'recoil'
import { DialogOptions } from '../types/dialog/dialog-options'

export const dialogState = atom<DialogOptions | undefined>({
  key: 'dialog-state',
  default: undefined
})
